export default "__VITE_ASSET__BDC_Ib1t__"